import ShiftListPage from '../pages/shift/shiftList/page'
import ShiftShowPage from '../pages/shift/show/page'

export const shiftRoutes = [
  { path: '/shift/list', element: <ShiftListPage /> },
  { path: '/shift/show/:securityFieldId', element: <ShiftShowPage /> },
]
